// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 90%;
  margin: 15px auto;
}

h3 {
  font-family: AppFontBold, sans-serif;
  margin-top: 15px;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
  font-size: 16px;
}

ion-input {
  --padding-start: 10px !important;
}

ion-item {
  --border-width: 1px !important;
  --border-radius: 52px !important;
  --border-color: #272727;
  --border-bottom: none;
  border: none;
}

.cross {
  height: 26px;
  width: 26px;
  position: absolute;
  right: 14px;
  top: 14px;
  cursor: pointer;
  margin: 0px;
  padding: 0px;
  z-index: 99;
}
.cross ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}

.button-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  gap: 12px;
}
.button-block ion-button {
  width: 60%;
  min-height: 40px;
  color: white;
  font-size: 14px;
  margin: 0 auto;
}

ion-icon {
  z-index: 10;
}

span {
  margin: 10px 0px;
}

.email-msg {
  margin: 0px;
  margin-bottom: 0px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 8px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-restore-password-modal/app-restore-password-modal.component.scss"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,iBAAA;AADF;;AAIA;EACE,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,gCAAA;AADF;;AAIA;EACE,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EAGA,WAAA;EACA,YAAA;EACA,WAAA;AAHF;AAKE;EACE,WAAA;EACA,YAAA;EACA,WAAA;AAHJ;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AAJF;AAME;EACE,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAJJ;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AALF","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n  width: 90%;\n  margin: 15px auto;\n}\n\nh3 {\n  font-family: AppFontBold, sans-serif;\n  margin-top: 15px;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 12px;\n  font-size: 16px;\n}\n\nion-input {\n  --padding-start: 10px !important;\n}\n\nion-item {\n  --border-width: 1px !important;\n  --border-radius: 52px !important;\n  --border-color: #272727;\n  --border-bottom: none;\n  border: none;\n}\n\n.cross {\n  height: 26px;\n  width: 26px;\n  position: absolute;\n  right: 14px;\n  top: 14px;\n  cursor: pointer;\n\n\n  margin: 0px;\n  padding: 0px;\n  z-index: 99;\n\n  ion-icon {\n    width: 100%;\n    height: 100%;\n    margin: 0px;\n  }\n}\n\n.button-block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  gap: 12px;\n\n  ion-button {\n    width: 60%;\n    min-height: 40px;\n    color: white;\n    font-size: 14px;\n    margin: 0 auto;\n  }\n}\n\nion-icon {\n  z-index: 10;\n}\n\nspan {\n  margin: 10px 0px;\n}\n\n.email-msg {\n  margin: 0px;\n  margin-bottom: 0px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
